import { Box, Button } from '@mui/material'
import { useEffect, useState } from 'react'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import { appendToUrl, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import * as id from '../reportId'
import * as lb from '../reportLables'
import * as reportUrls from '../oldReportsUrls'
import moment from 'moment/moment'
import { API_CACHE_DURATION, paymentModeAll, urls } from '../../../common/constants'
import { paymentModesWithAll, paytypes, TOPAY_COD_RULE } from '../../../common/paymentsMode'
import { useAtom, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest, GetRequestCachedV3 } from '../../../common/api'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import DropDownMultiSelectV2 from '../../../common/dropDownMultiSelectV2'
import LoaderModel from '../userWiseCollReport/loaderModel'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../common/jotaiState/reportStateAtom'
import useToken from '../../../helpers/useTokens'
import { GT_COMPANY_ID, PAYAL, TULSI_TRAVEL, VISHWA_COMPANY_ID } from '../../../../helper/companyIdhardcode'
import { getcolumnDefs, TRANSACTION_LABEL_MAP } from '../userWiseCollReport/constants'
import { groupDetailedTable } from '../userWiseCollReport/utilFucntions'
import { useSearchParams } from 'react-router-dom'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'
import { getDecryptedReportParams } from '../../../common/loginDecode'
import { criteriaHeaders, excludeCashPaymentModes, getMainHeader, ModesData, normalizeTableData, reportViewData, transactionsData } from './constants'

const CardAndUpiReport = () => {
    const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const reportName = 'Card and UPI'

  const [selCompany, setSelCompany] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selBranch, setSelBranch] = useState()
  const [selUser, setSelUser] = useState([])
  const [userStatusList, setUserStatusList] = useState([])
  const [transaction, setTransaction] = useState(transactionsData[0])
  const [paymentMode, setPaymentMode] = useState(paymentModeAll)
  const [paymentModeData, setPaymentModeData] = useState([])
  const [reportView, setReportView] = useState(reportViewData?.[0])
  const [ownChildBranches, setOwnChildBranches] = useState([])
  const [branchCities, setBranchCities] = useState([])
  const [ownChildUsers, setOwnChildUsers] = useState([])
  const [modal, setModal] = useAtom(modalAtom)
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)

  const [companySettings] = useAtom(companySettingsAtom)
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, AllowBranchInchargeRights, AllowGroupofCompanies } = { ...roleRightsData }
  const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
  const UseFormattedLRinReports = companySettings?.UseFormattedLRinReports
  const UseToPayAsCOD = companySettings?.UseToPayAsCOD

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intBranchCityID = +searchParams.get('CT') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    AllowViewAllBranchOfCityReport = +searchParams.get('AllowViewAllBranchOfCityReport') || 0
    AllowViewAllBranchReport = +searchParams.get('AllowViewAllBranchReport') || 0
    AllowGroupofCompanies = +searchParams.get('AllowGroupofCompanies') || 0
    isFromUrl = true
  }
  let { DefaultCurrencyID } = companySettings
  if (!DefaultCurrencyID) {
    DefaultCurrencyID = +searchParams.get('DC') || 1
  }

  const { intCompanyID, IsAdmin, intBranchID, intBranchCityID, intUserID, strCompanyName, IsBranchAdmin, strBranchName, IsMTPLAdmin } =
    loginData

  const disableBtn = !(AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin)

  const updatedPaymentModes = !UseToPayAsCOD
    ? paymentModesWithAll
    : paymentModesWithAll
        .map((item) => {
          if (item.typeId === paytypes.COD) return null
          const codName = TOPAY_COD_RULE[item.typeId]
          return codName ? { ...item, name: codName } : item
        })
        .filter(Boolean)

  const isVishwaCompany = intCompanyID === VISHWA_COMPANY_ID
  const transactionOptions = isVishwaCompany
    ? transactionsData.filter((item) => item.transactionId !== 1 && item.transactionId !== 2)
    : transactionsData
  const paymentTypeOptions = isVishwaCompany
    ? updatedPaymentModes.filter((item) => item.typeId !== paytypes.ON_ACCOUNT && item.typeId !== paytypes.ONACCOUNT_MANUAL)
    : updatedPaymentModes

  const [paymentType, setPaymentType] = useState(updatedPaymentModes[0])

  useEffect(() => {
    if (AllowGroupofCompanies === 1) {
      const defaultCompany = ChildCompanyList.find((v) => v.CompanyID === intCompanyID) || ChildCompanyList[0]
      setSelCompany(defaultCompany)
    } else {
      setSelCompany({
        CompanyID: intCompanyID,
        CompanyName: strCompanyName,
      })
    }
  }, [AllowGroupofCompanies, ChildCompanyList, intCompanyID, strCompanyName])

  useEffect(() => {
    if (!isEmpty(loginData)) {
      const body = {
        intCompanyID: intCompanyID,
        UserID: intUserID,
      }
      fetchChildCompanyList(body)
    }
  }, [fetchChildCompanyList, intCompanyID, intUserID])

  useEffect(() => {
    focusElemnt('UWFromDate')
  }, [])

  useEffect(() => {
    if (intUserID) {
      const branchData = {
        intUserID,
        intCompanyID,
        intIsActive: -1,
      }

      const fetchBranchAndUserData = async () => {
        setLoader(true)
        const [branchRes, userRes] = await Promise.all([
          GetRequestCachedV3(urls.getOwnAndChildBranchList, branchData, true, API_CACHE_DURATION),
          GetRequestCachedV3(urls.getOwnAndChildUsersList, branchData, true, API_CACHE_DURATION),
        ])
        setLoader(false)

        if (branchRes?.status === 'Success' && branchRes?.Data?.Table?.length > 0) {
          setOwnChildBranches(branchRes.Data.Table)
          setBranchCities(branchRes.Data.Table1 || [])
          setSelBranch(branchRes.Data.Table.find((val) => val.BranchID === intBranchID) || branchRes.Data.Table[0])
        } else {
          setAlert({ show: true, msg: branchRes?.ErrMessage })
          setOwnChildBranches([])
          setBranchCities([])
        }

        if (userRes?.status === 'Success' && userRes?.Data?.Table?.length > 0) {
          setOwnChildUsers(userRes.Data.Table)
          setSelUser(userRes.Data.Table.filter((val) => val.UserID === intUserID) || [])
        } else {
          setOwnChildUsers([])
          setAlert({ show: true, msg: userRes?.ErrMessage })
        }
      }

      fetchBranchAndUserData()
    }
  }, [intBranchID, intCompanyID, intUserID, setAlert, setLoader])
  
  useEffect(() => {
    const paymentModeBranchId = selBranch?.BranchID === 0 ? intBranchID : selBranch?.BranchID
    if (paymentModeBranchId) {
      const fetchPaymentModeData = async () => {
        setLoader(true)
        const res = await GetRequestCachedV3(urls.getMOFPayment, { intBranchID: paymentModeBranchId }, true, API_CACHE_DURATION)
        setLoader(false)

        if (res?.status === 'Success' && res?.Data?.Table?.length > 0) {
          setPaymentModeData([paymentModeAll, ...excludeCashPaymentModes(res.Data.Table)])
        } else {
          setPaymentModeData([])
          setAlert({ show: true, msg: res?.ErrMessage })
        }
      }

      fetchPaymentModeData()
    }
  }, [intBranchID, selBranch?.BranchID, setAlert, setLoader])

  useEffect(() => {
    if (selUser.length) {
      setUserStatusList(
        selUser.map((val) => ({
          loaded: 0,
          data: [],
          UserID: val.UserID,
          UserName: val.UserName,
        }))
      )
    } else {
      setUserStatusList([])
    }
  }, [selUser])

  const getReportData = async (data) => {
    const res = await GetRequest(urls.getCardAndUpiUserwiseCollection, data)
    if (res?.status === 'Success') {
      const updatedData = { ...res.Data }
      if (UseToPayAsCOD === 1 && Array.isArray(updatedData.Table)) {
        updatedData.Table = updatedData.Table.map((item) => ({
          ...item,
          TYPE: TOPAY_COD_RULE[item.PaymentTypeInt] || item.TYPE,
        }))
      }
      return updatedData
    } else {
      setAlert({ show: true, msg: res?.ErrMessage })
      return []
    }
  }

  const availableUsers = [
    { UserName: 'All Users', UserID: 0 },
    ...(ownChildUsers?.filter((val) => (selBranch?.BranchID === 0 || val?.BranchID === selBranch?.BranchID) && val?.IsUserActive) || []),
  ]

  const isAllUsersSelected = availableUsers.length > 0 && selUser.length === availableUsers.length
  const selectedUsersText = !selUser.length ? '' : isAllUsersSelected ? 'All' : selUser.map((val) => val.UserName).join(', ')
  const reportUserLabel = selUser.length === 1 ? selUser[0].UserName : isAllUsersSelected ? 'All' : 'Selected Users'
  
  const criteriaData = {
    fromDate: fromDate.format('DD-MM-YYYY') || '',
    toDate: toDate.format('DD-MM-YYYY') || '',
    selBranch: selBranch?.BranchName || '',
    selUser: selectedUsersText,
    transactionType: transaction?.Transactions || '',
    paymentType: paymentType?.name || '',
    paymentMode: paymentMode?.ModeName || '',
    selReportView: reportView?.view || '',
    dataType: 'entry',
  }

  const generateReportRequest = (userId) => {
    return {
      CompanyID: selCompany?.CompanyID,
      BranchID: selBranch?.BranchID,
      UserID: userId,
      dtFrom: moment(fromDate).format('YYYY-MM-DD'),
      dtTo: moment(toDate).format('YYYY-MM-DD'),
      PaymentTypeIDs: paymentType?.typeId,
      Modes: ModesData[transaction?.transactionId],
      PaymentModeIDs: paymentMode?.ModeID,
    }
  }

  const openViewReport = (reportPayload, isPdf = false) => {
    if (isPdf) {
      downloadPDF({
        reportName: reportPayload.reportName,
        criteriaHeaders: reportPayload.criteriaHeaders,
        criteriaData: reportPayload.criteriaData,
        tableData: reportPayload.tableData,
        visibleColumns: reportPayload.mainHeader,
        loginData,
        hideHeader: reportPayload.hideHeader || false,
      })
      return
    }
    const rid = Date.now().toString()

    if (!window.generatedReports) {
      window.generatedReports = {}
    }

    window.generatedReports[rid] = reportPayload
    window.open(`/view-report?rid=${rid}`, '_blank')
  }

  const getReportUserDetail = () => {
    if (selBranch?.BranchID === 0) {
      return [{ Branchname: 'All', Cityname: 'All Cities', Statename: 'All States' }]
    }

    const city = branchCities.find((item) => Number(item.CityID) === Number(selBranch?.CityID))
    return [
      {
        Branchname: selBranch?.BranchName || '',
        Cityname: city?.CityName || '',
        Statename: city?.StateName || '',
      },
    ]
  }

  const getReportPayload = (reportData) => {
    const userDetail = getReportUserDetail()
    const bookingColumns = getcolumnDefs(UseFormattedLRinReports, DefaultCurrencyID, TRANSACTION_LABEL_MAP.BKNG)
    const deliveryColumns = getcolumnDefs(UseFormattedLRinReports, DefaultCurrencyID, TRANSACTION_LABEL_MAP.DEL)
    const refundColumns = getcolumnDefs(UseFormattedLRinReports, DefaultCurrencyID, TRANSACTION_LABEL_MAP.RFND)

    return {
      reportName: 'Card and UPI Report (Detailed)',
      criteriaHeaders,
      criteriaData: [criteriaData],
      tableData: normalizeTableData(
        groupDetailedTable(
          reportData?.Table || [],
          reportUserLabel,
          1,
          [],
          userDetail,
          bookingColumns,
          deliveryColumns,
          refundColumns
        )
      ),
      mainHeader: getMainHeader(bookingColumns),
      hideHeader: true,
      serialNokey: 'SN',
    }
  }

  const validateFilters = () => {
  const diffDays = Math.abs(toDate.diff(fromDate, 'days'))

  if (selBranch?.BranchID === undefined || selBranch?.BranchID === null) {
    setAlert({ show: true, msg: 'Select Branch', nextId: '' })
    return false
  }

  if (!selUser.length) {
    setAlert({ show: true, msg: 'Select Company User', nextId: '' })
    return false
  }

  if (selUser.length === 1 && diffDays > 31) {
    setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    return false
  }

  if (selUser.length > 1 && diffDays > 15) {
    setAlert({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
    return false
  }

  return true
}

  const handleClick2 = () => {
    if (!validateFilters()) return

    let url = reportUrls.userWiseCollection
    const urlData = reportUrls.userWiseCollectionParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.FromDt = fromDate.format('YYYY-MM-DD')
    urlData.ToDt = toDate.format('YYYY-MM-DD')
    urlData.BranchID = selBranch.BranchID
    urlData.UserID = selUser[0].UserID
    urlData.Summary = reportView?.id
    urlData.TransType = transaction.transactionId
    urlData.PaymentMode = paymentMode?.ModeID
    urlData.intCargoParentCompanyID = intCompanyID
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }

  const handleClick1 = async (isPdf = false) => {
    if (!validateFilters()) return

    if (selUser.length === 1 || selUser[0].UserID === 0) {
      setLoader(true)
      const reportData = await getReportData(generateReportRequest(selUser[0].UserID))
      setLoader(false)
      if (!reportData?.Table?.length) {
        setAlert({ show: true, msg: 'No Data found' })
        return
      }
      openViewReport(getReportPayload(reportData), isPdf)
      return
    }

    setModal('loaderModal')
    const reportDataList = []

    for (let i = 0; i < selUser.length; i++) {
      const userId = selUser[i].UserID
      setUserStatusList((prevList) => prevList.map((item) => (item.UserID === userId ? { ...item, loaded: 1 } : item)))
      const reportData = await getReportData(generateReportRequest(userId))
      setUserStatusList((prevList) => prevList.map((item) => (item.UserID === userId ? { ...item, loaded: 2 } : item)))
      reportDataList.push(reportData)
    }

    setModal()
    const mergedReportData = {
      Table: reportDataList.flatMap((item) => (Array.isArray(item?.Table) ? item.Table : [])),
    }
    if (!mergedReportData.Table.length) {
      setAlert({ show: true, msg: 'No Data found' })
      return
    }
    openViewReport(getReportPayload(mergedReportData), isPdf)
  }

  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSelBranch({ BranchName: strBranchName, BranchID: intBranchID })
    setSelUser([])
    setTransaction(transactionsData[0])
    setPaymentType(updatedPaymentModes?.[0])
    setPaymentMode(paymentModeAll)
    setReportView(reportViewData?.[0])
  }
  
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <ReportHeading reportName={reportName} />}
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
          {!isFromUrl && (
            <Item sx={sx.itemsxGrow}>
              <DropDownOA
                id={id.selectCompnay}
                label={lb.select_company}
                data={ChildCompanyList}
                defaultvalue={selCompany?.CompanyName}
                disabled={AllowGroupofCompanies === 1 ? false : true}
                onSelect={(e) => {
                  setSelCompany(e)
                }}
                dataKey={`CompanyName`}
                idKey={`CompanyID`}
                width="100%"
              />
            </Item>
          )}
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={lb.from_collection_date}
              id={'UWFromDate'}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt('UWToDate')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              label={lb.to_collection_date}
              value={toDate}
              id={'UWToDate'}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt(id.selBranch)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={lb.select_branch}
              id={id.selBranch}
              data={[
                { BranchName: 'All', BranchID: 0 },
                ...(AllowViewAllBranchOfCityReport === 1 && AllowViewAllBranchReport === 0
                  ? ownChildBranches.filter((val) => val.CityID === intBranchCityID)
                  : ownChildBranches || []),
              ]}
              defaultvalue={(ownChildBranches?.length > 0 && selBranch?.BranchName) || ''}
              disabled={disableBtn && AllowViewAllBranchOfCityReport === 0}
              dataKey={`BranchName`}
              idKey={`BranchID`}
              onSelect={(val) => {
                setSelBranch(val)
                setSelUser([])
              }}
              width="100%"
              nextId={id.userLIst}
              prevId={'UWToDate'}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownMultiSelectV2
              id={id.userLIst}
              label={'Branch User'}
              defaultvalue={selUser}
              data={availableUsers}
              dataKey={`UserName`}
              idKey={`UserID`}
              onSelect={(list) => {
                setSelUser(list)
              }}
              HasAllSelect={true}
              width={isFromUrl ? '100%' : 'auto'}
              nextId={'UWTransaction'}
              prevId={id.selBranch}
              disabled={[GT_COMPANY_ID, PAYAL, TULSI_TRAVEL].includes(intCompanyID) ? false : disableBtn && AllowViewAllBranchOfCityReport === 0}
            />
          </Item>
        </Box>
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '170px' }}>
            <DropDownOA
              id={'UWTransaction'}
              defaultvalue={transaction?.Transactions}
              data={transactionOptions}
              width="100%"
              searchPlaceholder={`Search Transactions`}
              label={'Transaction Type'}
              tabIndex="2"
              dataKey={`Transactions`}
              idKey={`transactionId`}
              onSelect={(value) => {
                setTransaction(value)
              }}
              nextId={'UWPaymentType'}
              prevId={id.userLIst}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '175px' }}>
            <DropDownOA
              id="UWPaymentType"
              data={paymentTypeOptions}
              defaultvalue={paymentType?.name}
              width="100%"
              searchPlaceholder={`Search By Payment Type`}
              label={'Payment Type'}
              tabIndex="2"
              dataKey={`name`}
              idKey={`typeId`}
              onSelect={(value) => {
                setPaymentType(value)
              }}
              nextId={'UWPaymentMode'}
              prevId={'UWTransaction'}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '270px' }}>
            <DropDownOA
              id="UWPaymentMode"
              data={paymentModeData}
              defaultvalue={paymentModeData?.length > 0 && paymentMode?.ModeName}
              width="100%"
              searchPlaceholder={`Search By Payment Mode`}
              label={'Payment Mode'}
              tabIndex="2"
              dataKey={`ModeName`}
              idKey={`ModeID`}
              onSelect={(value) => {
                setPaymentMode(value)
              }}
              nextId={'UWReportView'}
              prevId={'UWPaymentType'}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '268px' }}>
            <DropDownOA
              id="UWReportView"
              defaultvalue={reportView?.view}
              data={reportViewData}
              width="100%"
              searchPlaceholder={`Search By View`}
              label={'Report View'}
              tabIndex="2"
              dataKey={`view`}
              idKey={`id`}
              onSelect={(value) => {
                setReportView(value)
              }}
              nextId={'UWSplitButton'}
              prevId={'UWPaymentMode'}
            />
          </Item>
          {isFromUrl ? (
            <Button
              variant="contained"
              sx={{ width: '100%', height: '40px' }}
              className="btn btn-primary"
              onClick={() => handleClick1(true)}
              id1={'UWSplitButton'}
            >
              DOWNLOAD PDF
            </Button>
          ) : (
            <>
              <Item
                sx={sx.itemsx}
                style={{ cursor: 'pointer' }}
                onKeyDown={(e) => navigation3(e, 'UWFromDate', 'UWReportView', () => handleClick1())}
              >
                <SplitButton
                  options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                  id1={'UWSplitButton'}
                  prevID={id.summaryCheck}
                  onClick1={() => handleClick1()}
                  onClick2={handleClick2}
                />
              </Item>
              <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
                <RefreshSvg width={'24px'} height={'24px'} />
              </Item>
            </>
          )}
        </Box>
      </Item>
      {modal === 'loaderModal' && <LoaderModel list={userStatusList} headTxt="Loading Card and UPI for all Users" />}
    </>
  )
}
export default CardAndUpiReport
